import React from 'react';

import { Text } from '@auspost/postmaster-react';

import { DialogueCardData } from '../../../../models/DialogCard';
import {
  DIALOGUE_CARD_BUTTONS_TEST_ID,
  DIALOGUE_CARD_CONTENT_TEST_ID,
  DIALOGUE_CARD_TEST_ID,
} from './DialogueCard.test-ids';

import styles from './DialogueCard.module.scss';

interface DialogueCardProps {
  dialogueCard?: DialogueCardData | null;
}
const DialogueCard: React.FC<DialogueCardProps> = ({ dialogueCard }) => {
  if (!dialogueCard) return null;
  const { type, title, content, icon, actions, customContent } = dialogueCard;
  if (!type || !title || !content || !icon) return null;

  return (
    <div className={styles.dialogueCardWrapper} data-testid={DIALOGUE_CARD_TEST_ID}>
      <div className={styles.dialogueCardIcon}>{icon}</div>
      <div className={styles.dialogueCard}>
        <Text variant='subtitle' className={styles.label}>
          {type}
        </Text>
        <Text variant='body-small' weight='bold' className={styles.title}>
          {title}
        </Text>
        <div className={styles.content} data-testid={DIALOGUE_CARD_CONTENT_TEST_ID}>
          {content}
          <div className={styles.customContent}>{customContent}</div>
        </div>
      </div>
      {actions && (
        <div className={styles.dialogueCardButtons} data-testid={DIALOGUE_CARD_BUTTONS_TEST_ID}>
          {actions}
        </div>
      )}
    </div>
  );
};

export default DialogueCard;
